import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HCMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
import HighchartsReact from "highcharts-react-official";

HCMore(Highcharts);
solidGauge(Highcharts);

const DonutPro = (props) => {
  const rank = props?.data?.value;
  const [chartLoaded, setChartLoaded] = useState(false);
  const [initialRender, setInitialRender] = useState(true);
  const [options, setOptions] = useState({});
  const [prevValue, setPrevValue] = useState(undefined);

  function addSuffixToNumber(number) {
    const suffixes = ["th", "st", "nd", "rd"];
    const lastTwoDigits = number % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
      return number + "th";
    }

    const lastDigit = number % 10;
    return `${number}<sup>${suffixes[lastDigit] || "th"}</sup>`;
  }

  useEffect(() => {
    if (initialRender) {
      setOptions({
        chart: {
          type: "solidgauge",
          margin: [0, 0, 0, 0],
          backgroundColor: "transparent",
        },
        title: {
          text: "",
        },
        tooltip: {
          enabled: false,
        },
        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [
            {
              outerRadius: "85%",
              innerRadius: "60%",
              borderWidth: 0,
              backgroundColor: props?.data?.bgcolor,
            },
          ],
        },
        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: [],
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: false,
              format:
                props?.data?.isDisplayVal &&
                `<div style="text-align: center;">
                  <span style="font-size: 60px; color: #FBC809;">${addSuffixToNumber(
                    rank
                  )}</span><br/>
                </div>`,
              verticalAlign: "middle",
              borderWidth: 0,
              useHTML: false,
            },
            shadow: false,
          },
        },
        series: [
          {
            data: [
              {
                name: props?.name,
                color: "red",
                radius: "85%",
                innerRadius: "60%",
                y: parseInt(props.data.value),
              },
            ],
          },
        ],
      });

      setPrevValue(props.data.value);
      setChartLoaded(true);
      setInitialRender(false);
    } else if (props?.data?.value !== prevValue) {
      setOptions((prevOptions) => ({
        ...prevOptions,
        series: [
          {
            ...prevOptions.series[0],
            data: [
              {
                ...prevOptions.series[0].data[0],
                y: parseInt(props.data.value),
              },
            ],
          },
        ],
      }));

      setPrevValue(props.data.value);
    }
  }, [props, prevValue, initialRender]);

  return (
    chartLoaded ?
      <HighchartsReact
        options={props?.data?.value === undefined ? null : options}
        highcharts={Highcharts}
        containerProps={{ className: "custom-circle-progress label-center" }}
      />
      : null
  );
};

export default DonutPro;
